import { CalendarClock, X, XCircle } from "lucide-react";
import { confirmAction } from "../../../utils/toastUtils";

const JobActionModal = ({
  isOpen,
  job,
  onClose,
  onReschedule,
  onCancel,
  showUndoOption,
  undoStartWork,
}) => {
  if (!isOpen || !job) return null;

  if (job.status === "cancelled") return;

  const handleUndoClick = async () => {
    const confirmed = await confirmAction({
      title: "Undo Start Work?",
      text: "This will move the job back to Accepted since work hasn’t started yet.",
      confirmText: "Yes, Undo",
      cancelText: "Keep Started",
      icon: "info",
    });

    if (!confirmed) return;
    undoStartWork(job?.id);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={onClose}
    >
      {/* Modal */}
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          w-[92vw] max-w-[420px]
          bg-white
          rounded-2xl
          p-6
          space-y-5
          animate-slideUp
          shadow-xl
        "
      >
        {/* Header */}
        <div className="relative text-center">
          <button
            onClick={onClose}
            className="absolute right-0 top-0 p-1 rounded-full active:bg-gray-100"
          >
            <X size={18} className="text-gray-400" />
          </button>

          <p className="text-sm font-semibold text-primaryTextColor">
            {job.customerName}
          </p>
          <p className="text-xs text-secondaryTextColor">{job.service}</p>
        </div>
        {job.status === "ongoing" && showUndoOption && (
          <div className=" rounded-xl  bg-amber-50 border border-amber-200 px-4 py-2 text-sm text-amber-800 ">
            <p className="font-medium">
              Clicked “Start Work” by mistake?{" "}
              <button
                onClick={handleUndoClick}
                className="px-2 cursor-pointer text-[0.9em] underline underline-offset-1 text-primaryBtnColor hover:text-primaryBtnHoverColor"
              >
                Undo here
              </button>
            </p>
            <p className="mt-0.5 leading-relaxed text-[0.8em]">
              Don’t worry - you have a{" "}
              <span className="font-semibold">5-minute grace period</span> to
              undo it if you’re not at the location yet.
            </p>
          </div>
        )}

        {/* Reschedule */}
        {job.status !== "ongoing" && (
          <button
            onClick={onReschedule}
            className=" w-full h-12 rounded-xl bg-gray-100 hover:bg-gray-200 active:bg-gray-200 font-semibold text-primaryTextColor flex items-center justify-center gap-2 transition-colors "
          >
            <CalendarClock size={18} />
            Reschedule Job
          </button>
        )}

        {/* Cancel */}
        <button
          onClick={onCancel}
          className="
            w-full h-12
            rounded-xl
            bg-red-50 hover:bg-red-100 active:bg-red-100
            text-red-600
            font-semibold
            flex items-center justify-center gap-2
            transition-colors
          "
        >
          <XCircle size={18} />
          Mark Unavailable{" "}
        </button>

        {/* Close */}
        <button
          onClick={onClose}
          className="
            w-full h-10
            text-secondaryTextColor
            font-medium
          "
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default JobActionModal;
